import { Dropdown } from 'react-bootstrap'
import { useUser } from '@ztechapps/common.hook'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUser, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

export const UserDropdown = () => {
  const { user, logout } = useUser()
  const userName = user?.profile?.name ?? ''
  const userLogo = user?.profile?.picture

  return (
    <div className="topbar-item nav-user">
      <Dropdown>
        <Dropdown.Toggle as="button" type="button" className="topbar-link border-0 bg-transparent">
          {userLogo ? (
            <img src={userLogo} width={32} height={32} className="rounded-circle me-lg-2 d-flex" alt="user" />
          ) : (
            <span className="avatar-sm me-lg-2 d-flex">
              <span className="avatar-title rounded-circle text-bg-light">
                <FontAwesomeIcon icon={faUser} className="text-muted" />
              </span>
            </span>
          )}
          <div className="d-lg-flex align-items-center d-none">
            <h6 className="my-0 fw-medium">{userName}</h6>
          </div>
        </Dropdown.Toggle>
        <Dropdown.Menu className="dropdown-menu-end">
          <Dropdown.Header>
            <h6 className="text-overflow m-0">Welcome, {userName?.split(' ')[0] ?? 'User'}!</h6>
          </Dropdown.Header>
          <Dropdown.Divider />
          <Dropdown.Item className="text-danger fw-semibold" onClick={() => logout()}>
            <FontAwesomeIcon icon={faSignOutAlt} className="me-2 align-middle" />
            <span className="align-middle">Log Out</span>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  )
}
